<template src="./activityOnlineTest.html"></template>

<script>
import onlineTestBasicDetails from "./onlineTestBasicDetails/onlineTestBasicDetails"
import onlineTestQuestions from "./onlineTestQuestions/onlineTestQuestions"
import onlineTestAssignStudents from "./onlineTestAssignStudents/onlineTestAssignStudents"
import onlineTestAnalysis from "./onlineTestAnalysis/onlineTestAnalysis"
import onlineTestStudentMarks from "./onlineTestStudentMarks/onlineTestStudentMarks.vue"
export default {
  name: "activityOnlineTest",
  components: {
    onlineTestBasicDetails,
    onlineTestQuestions,
    onlineTestAssignStudents,
    onlineTestAnalysis,
    onlineTestStudentMarks
  },
  props: [
    'prop_tabNumber',
    'instituteToBeSet',
    'semesterToBeSet',
    'prop_selectedSubject',
    'disableTabs'
  ],
  data() {
    return {
      backgroundColor: "#E7E7FFCF",
      downArrow: "mdi-chevron-down",
      upArrow: "mdi-arrow-up",
      examTypes: ['Exam'], //'Theory', 'Online'
      examType: '',
      mainTabNames: ['Basic Details', 'Questions', 'Assign Students', 'View Analysis'],
      components: ['onlineTestBasicDetails', 'onlineTestQuestions', 'onlineTestAssignStudents', 'onlineTestAnalysis', 'onlineTestStudentMarks'],
      currentTab: 0,
      tabs: 0,
      selectedInstitute: '',
      selectedSemester: '',
      selectedDepartment: '',
      selectedCourseYear: '',
      selectedRadio: null,
      selectedObjectTest: {},
      isTabsDisabled: false
    }
  },
  async created() {
    this.selectedInstitute = this.$store.getters["instituteData/get_selectedInstitute"];
    this.selectedSemester = this.$store.getters["instituteData/get_selectedSemester"];
    this.selectedDepartment = this.$store.getters["liveData/get_examDepartment"];
    this.selectedCourseYear = this.$store.getters["liveData/get_examCourseYear"];
    this.selectedObjectTest = this.$store.getters["liveData/get_selectedObjectTest"];
    if (this.selectedObjectTest.analysis) {
      this.currentTab = 3
      console.log('this.selectedObjectTest', this.selectedObjectTest);
    }
    console.log('this.selectedObjectTestBase', this.selectedObjectTest);
    if (this.disableTabs) this.isTabsDisabled = true
    if (this.prop_tabNumber) this.currentTab = this.prop_tabNumber
  },
  computed: {
    currentTabComponent() {
      return this.components[this.currentTab];
    }
  },
  methods: {
    handleConductionChange(selectedRadio, tabIndex, showTabs) {
      console.log('tabIndex', tabIndex);
      if (selectedRadio) {
        console.log('selectedRadio', selectedRadio);
        this.selectedRadio = selectedRadio;
      }

      // Adjust mainTabNames based on the selectedRadio value
      const baseTabs = ['Basic Details', 'Questions', 'Assign Students', 'View Analysis', 'Student Marks'];

      if (selectedRadio && selectedRadio === "1") {
        this.mainTabNames = baseTabs.filter(tab => tab !== 'Student Marks');
      } else if (selectedRadio && selectedRadio === "2") {
        this.mainTabNames = baseTabs.filter(tab => tab !== 'View Analysis' && tab !== 'Assign Students');
      }

      // Ensure currentTab stays within bounds
      if (this.currentTab >= this.mainTabNames.length) {
        this.currentTab = this.mainTabNames.length - 1;
      }
      if (tabIndex) {
        this.currentTab = tabIndex;
      }
      if (showTabs === false) {
        console.log('showTabs', showTabs);
        this.isTabsDisabled = showTabs
      }
    },
    // Dynamically return the component to render based on the tab name
    getComponentForTab(tabName) {
      switch (tabName) {
        case 'Basic Details':
          return 'onlineTestBasicDetails';
        case 'Questions':
          return 'onlineTestQuestions';
        case 'Assign Students':
          return 'onlineTestAssignStudents';
        case 'View Analysis':
          return 'onlineTestAnalysis';
        case 'Student Marks':
          return 'onlineTestStudentMarks';
        default:
          return null;
      }
    },
    handleNextButtonClick() {
      // Increment the currentTab value to move to the next tab
      this.currentTab += 1;
    },
    goBack() {
      console.log('this.selectedObjectTest', this.selectedObjectTest);
      this.$store.commit("liveData/set_selectedObjectTest", {});
      const testDetailsChanged = {
        basicDetails: false,
        questions: false,
        studentAllocation: false
      }
      this.$store.commit("liveData/set_testDetailsChanged", testDetailsChanged);
      this.$router.push({
        name: 'activityNewAssignments',
        params: {
          prop_department: this.selectedObjectTest?.prop_department,
          prop_course: this.selectedObjectTest?.prop_course,
          prop_selectedSubject: this.selectedObjectTest?.prop_selectedSubject,
          prop_typeDivGrpBatch: this.selectedObjectTest?.prop_typeDivGrpBatch,
          prop_selectedDivision: this.selectedObjectTest?.prop_selectedDivision,
          prop_selectedBatch: this.selectedObjectTest?.prop_selectedBatch,
          prop_selectedGroup: this.selectedObjectTest?.prop_selectedGroup,
          prop_examType: "Online Test"
        }
      })
    },
    beforeDestroy() {
      this.$store.commit(
        "liveData/set_selectedInstitute",
        this.instituteToBeSet
      );
      this.$store.commit(
        "liveData/set_selectedSemester",
        this.semesterToBeSet
      );
    }
  }
}
</script>

<style src="./activityOnlineTest.css"></style>
